export default __webpack_public_path__ + "static/media/3.2500015d.png";